// follow up options
export const SMALL_GROUP_AND_INDEPENDENT = "Small Group Instruction and Independent Practice"
export const PRACTICE_NOW = "All Students Practice Now"
export const PRACTICE_LATER = "All Students Practice Later"
export const NO_PRACTICE = "No Follow Up Practice"
